export default {
    'UsedTime': 'Used time:{time}',
    'UsedTimeNew': 'Elapsed Time:',
    'FlowTrack': 'Workflow Track',
    'Participant': 'Current Approver',
    'Participants': 'Current Approvers:',
    'FinishNode': 'Ended Activities',
    'ProcessNode': 'Processing Activities',
    'WrongNode': 'Unusual Activity',
    'UnstartNode': 'Unstarted Activity',
    'Person': '{length} person',
    'chartTips': 'Flowchart can be resized by gesture',
    'trust': '【{name} Delegated】',
    approvalLog: {
        circulateNum: 'Ciruation {num} persons',
        circulatedNum: 'Read {num} persons',
        uncirculateNum: 'Unread {num} persons',
        turnover: 'Turnover',
        newOwner: 'New Owner',
        handlingSuggestion: 'Handling Suggestion',
        operator: 'Operator',
        newHandler: 'New Handler',
        workflowAdjust: 'WorkflowAdjust',
        nodeAdjust: 'NodeAdjust',
        whoseAdjustParticipant: "{who}'s Add-approver",
        whoseTransfer: "{who}'s Transfer"
    },
    WorkflowActions: {
        Nullify: 'Cancel workflow',
        Delete: 'Delete workflow',
        ActivateNode: 'activate other nodes',
        AdjustHandler: 'Adjust current handler',
        FinishInstance: 'End-workflow',
        EditOwner: 'Modify owner',
        EditTemplate: 'Modify workflow template',
        CancelAllTask: 'Cancel all task of the activity',
        SelectHandler: 'Select current handler',
        CancelTips1: 'After canceling all tasks of the current node, the process will stay at the current node',
        SelectNode: 'Select Node',
        pleaseSelect: "Please select",
        DELETE_WORKFLOW: 'All workflow data will be delete after workflow instance be deleted, and it can not restore after delete, Are you sure to delete?',
        COMPLETED_WORKFLOW: 'Are you sure to end the workflow?',
        ADJUST_PARTICIPANT: 'Are you sure you want to adjust the current handler?',
        MODIFY_OWNER: 'Are you sure to modify the owner?',
        ACTIVATE_ACTIVITY: 'Are you sure to activate this node${activityName}?',
        CANCELED_ACTIVITY_WORKITEM: 'Are you sure to cancel all tasks of the current node?',
        CANCELED_WORKFLOW: 'The process will stop circulating after it is invalidated, Sure to void?',
        ACTIVATE_ACTIVITY_EMPTY: 'Activation node cannot be empty!',
        ADJUST_PARTICIPANT_EMPTY: 'The current handler cannot be empty!',
        MODIFY_OWNER_EMPTY: 'Owner cannot be null!',
        MODIFY_OWNER_DEPARTMENT_EMPTY: 'Owner Department cannot be null!',
    },
    approvalInfo: {
        action: "Action",
        owoner: "New Owner",
        department: "Owner department",
        node: "Select Node",
        processor: "New Handler",
        opinion: "Handling Suggestion",
        operator: "Operator",
        time: "Operation Time",
    },
    'WorkflowActionStatus': {
        'Submit': 'Submit',
        'Submits': 'Submit',
        'Cancel': 'Cancel',
        // 'Agree': 'Agree',
        'Agree': 'Approve',
        'DisAgree': 'Disagree',
        'AdjustParticipant': 'Add-approver',
        'ActivateActivity': 'Activate Other Nodes',
        'ADJUST_PARTICIPANT': 'Adjust Current Processor',
        'CANCELED_ACTIVITY_WORKITEM': 'Cancel All Tasks Of The Node',
        'MODIFY_OWNER': 'Modify Owner',
        'Assist': 'Assist',
        'Forward': 'Transfer',
        'Reject': 'Modify',
        'FinishInstance': 'End-workflow',
        'UnRead': 'Unread',
        'Read': 'Read',
        'Circularize': 'Circularize',
        'Empty': '',
        'Revoke': 'Revoke',
        'BeCanceled': 'Be Canceled',
        'AutoCanceled': 'Auto Cancel',
        'DECLINE': 'Decline'
    },
    'WorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Draft': 'Draft',
        'BeCanceled': 'Be Canceled',
    },
    'Operationworkflow': 'Operation Workflow',
};
